import './styles.css';
import './ui/ui.css';
import './shell/shell.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App.js';
import { createUserManager } from './auth/session.js';
import { loadConfig } from './config.js';
import { pickLocale } from './i18n/locale.js';
import { WORDS } from './i18n/words.js';

const element = document.getElementById('root');
if (element === null) throw new Error('index.html has no #root');
const root = createRoot(element);

loadConfig()
  .then((config) => {
    root.render(
      <StrictMode>
        <App config={config} manager={createUserManager(config)} />
      </StrictMode>,
    );
  })
  .catch(() => {
    // No config means no sign-in: say so plainly, in the browser's language.
    const t = WORDS[pickLocale(null, navigator.languages ?? [])];
    root.render(<p className="notice-text">{t.cannotStart}</p>);
  });
